$('.js-slider').slick({
	autoplay: true,
	autoplaySpeed: 3500,
	centerMode: true,
	centerPadding: '38px',
	variableWidth: true,
	arrows: true,
	prevArrow: '<img src="img/icon_prev.svg" class="js-arrow -prev">',
	nextArrow: '<img src="img/icon_next.svg" class="js-arrow -next">',
	dots: true,
	dotsClass: 'js-dots',
});
